import { t } from '@lingui/macro'

export const randStr = (length = 4) =>
  Math.random().toString(36).substring(2, length + 2)

export const toCamelCase = str =>
  str
    .replace(/^\w|\b\w/g, (letter, index) =>
      index === 0 ? letter.toLowerCase() : letter.toUpperCase()
    )
    .replace(/\s+/g, '')

export const fromCamelCase = str =>
  str
    .replace(/([A-Z])/g, ' $1')
    .replace(/^\w|\b\w/g, (letter, index) =>
      index === 0 ? letter.toUpperCase() : letter.toLowerCase()
    )

export const isStringEqual = standard => value => {
  return standard === value
}

/**
 * Combina due o più funzioni usando logica OR.
 * @param  {...Array<(input: T) => boolean>} funcs - Le funzioni da combinare.
 * @returns {(input: T) => boolean} - Una funzione composta che restituisce true se una delle funzioni è true.
 */
export function or (...funcs) {
  return input => funcs.some(func => func(input))
}

/* Combines and completes online organizations info with local info (ie. localized descripition and icon) */
export const interpolateOrgs = orgs => [
  { id: -1, basic_id: -1, value: -1, description: t`Admin`, label: t`Admin`, icon: 'security' }
  , ...orgs.map(org => ({ ...org, value: org.id, label: t`${org.description}` }))
]

/* IndexedDB Utility to store failed requests when offline. */
const DB_NAME = 'crashSyncDB'
const STORE_NAME = 'pendingRequests'
const STORE_PUBLIC_ACCIDENT = 'publicAccidentDrafts'

export function openDB (publicAccident = false) {
  console.log('ciao')
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME,  2)
    console.log('request openDb ', request)
    request.onerror = () => reject(new Error('Failed to open IndexedDB'))
    request.onsuccess = () => resolve(request.result)
    request.onupgradeneeded = event => {
      console.log('ev ', event)
      event.target.result.createObjectStore(!publicAccident ? STORE_NAME : STORE_PUBLIC_ACCIDENT, { keyPath: 'id', autoIncrement: true, unique: true })
    }
  })
}

export async function removeFromIndexedDB(key,publicAccident = false){
  console.log('key ... ', key)
  const db = await openDB()
  const transaction = db.transaction(!publicAccident ? STORE_NAME : STORE_PUBLIC_ACCIDENT, 'readwrite')
  const store = transaction.objectStore(!publicAccident ? STORE_NAME : STORE_PUBLIC_ACCIDENT)
  const deleteValue = store.delete(key)
  return deleteValue
  
}

export async function saveToIndexedDB (data,publicAccident = false) {
  const db = await openDB()
  const tx = db.transaction(!publicAccident ? STORE_NAME : STORE_PUBLIC_ACCIDENT, 'readwrite')
  tx.objectStore(!publicAccident ? STORE_NAME : STORE_PUBLIC_ACCIDENT).add(data)
  return tx.complete
}

export async function getPendingRequests () {
  const db = await openDB()
  console.log('db ---> ', db)
  const tx = db.transaction(STORE_NAME, 'readonly')
  return tx.objectStore(STORE_NAME).getAll()
}

export async function getPublicAccidentDrafts () {
  const db = await openDB(true)
  const tx = db.transaction(STORE_PUBLIC_ACCIDENT, 'readonly')
  return tx.objectStore(STORE_PUBLIC_ACCIDENT).getAll()
}

export async function clearIndexedDB (publicAccident = false) {
  const db = await openDB(publicAccident)
  const tx = db.transaction(!publicAccident ? STORE_NAME : STORE_PUBLIC_ACCIDENT, 'readwrite')
  tx.objectStore(!publicAccident ? STORE_NAME : STORE_PUBLIC_ACCIDENT).clear()
  return tx.complete
}
